import React, { useContext, useEffect, useRef, useState } from 'react';
import '../Notebook.css';
import { TbCheck, TbClockHour3, TbFolderSymlink, TbMessage, TbStar, TbStarFilled, TbTrash } from 'react-icons/tb';
import { BsThreeDots } from 'react-icons/bs';
import NoteCard from '../components/NoteCard/NoteCard';
import NoteSearchInput from '../components/NoteSearchInput/NoteSearchInput';
import AddNoteButton from '../components/AddNoteButton/AddNoteButton';
import { GeneralContext } from '../../../GeneralProvider';
import { ContentState, EditorState, convertToRaw, convertFromRaw } from 'draft-js';  // Import edildi
import { useLanguage } from '../../../LanguageProvider';
import NoteTextEditor from '../../../components/NoteTextEditor/NoteTextEditor';
import { TfiSave } from 'react-icons/tfi';
import NoteMoveFolderModal from '../components/NoteMoveFolderModal/NoteMoveFolderModal';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

export default function AllNotes({ initialSelectedNote, setSelectedSubmenuId, selectedFolderId }) {

    const { getTranslation } = useLanguage();
    const { getMyNotes, handleUpdateNote, handleCreateNote, handleDeleteNoteTemporary, handleUpdateNoteTitle, selectedNote, setSelectedNote, handleTouchNote, recentNotes, myNotes, handleStarNote, handleUnstarNote, handleMenuStarNote, handleMenuUnstarNote } = useContext(GeneralContext);
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [typingTimeout, setTypingTimeout] = useState(null); // Timeout state
    const [isEditingTitle, setIsEditingTitle] = useState(false);
    const [tempTitle, setTempTitle] = useState("");
    const titleInputRef = useRef(null);
    const [filteredNotes, setFilteredNotes] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [isSaved, setIsSaved] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const mergeNotes = () => {
        const folderNotes = myNotes.folders?.flatMap(folder => folder.notes);

        const otherNotes = myNotes.notes;

        const allNotes = [...folderNotes, ...otherNotes];
        return allNotes;
    };

    const handleSearch = (searchValue) => {
        setSearchText(searchValue);

        if (!searchValue.trim()) {
            setFilteredNotes(recentNotes);
            return;
        }

        const lowerSearch = searchValue.toLowerCase();

        const filtered = mergeNotes().filter(note => {
            const titleMatch = note.title?.toLowerCase().includes(lowerSearch);
            const contentMatch = note.content?.toLowerCase().includes(lowerSearch)
            return titleMatch || contentMatch;
        });

        setFilteredNotes(filtered);
    };

    useEffect(() => {
        setFilteredNotes(recentNotes);
    }, [recentNotes]);

    useEffect(() => {
        if (isEditingTitle && titleInputRef.current) {
            titleInputRef.current.select();
        }
    }, [isEditingTitle]);


    useEffect(() => {
        getMyNotes();
        setSelectedNote(initialSelectedNote || null);
        if (initialSelectedNote) {
            handleTouchNote(initialSelectedNote.noteId)
        }
    }, [initialSelectedNote]);

    const breadcrumb = () => {
        if (!selectedNote) return "";
        return selectedNote.folderTitle
            ? `${selectedNote.folderTitle} / ${selectedNote.title || getTranslation("untitled")}`
            : selectedNote.title || getTranslation("untitled");
    };

    // Veri çekme kısmı: Veritabanından gelen content'i dönüştürme
    useEffect(() => {
        if (selectedNote) {
            let html = ""
            if (selectedNote?.content?.blocks) {
                html = draftToHtml(selectedNote.content)
            }
            else {
                html = selectedNote.content || "";
            }
            const contentBlock = htmlToDraft(html);
            if (contentBlock) {
                const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks, contentBlock.entityMap);
                const newEditorState = EditorState.createWithContent(contentState);
                setEditorState(newEditorState);
            } else {
                setEditorState(EditorState.createEmpty());
            }
        } else {
            setEditorState(EditorState.createEmpty());
        }
    }, [selectedNote]);

    // Eğer initialSelectedNote varsa, onu da dönüştürüp set ediyoruz
    useEffect(() => {
        if (initialSelectedNote) {

            let html = ""
            if (initialSelectedNote?.content?.blocks) {
                html = draftToHtml(initialSelectedNote.content)
            }
            else {
                html = initialSelectedNote.content || "";
            }

            const contentBlock = htmlToDraft(html);
            if (contentBlock) {
                const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks, contentBlock.entityMap);
                const newEditorState = EditorState.createWithContent(contentState);
                setEditorState(newEditorState);
                setSelectedNote(initialSelectedNote);
                handleTouchNote(initialSelectedNote.noteId);
            } else {
                setEditorState(EditorState.createEmpty());
            }
        }
    }, [initialSelectedNote]);

    const handleSaveChanges = async () => {
        const currentContent = editorState.getCurrentContent();
        const rawContent = convertToRaw(currentContent);
        const htmlContent = draftToHtml(rawContent);

        if (htmlContent !== selectedNote.content) {
            await handleUpdateNote(selectedNote.noteId, htmlContent);
        }
        setIsSaved(true);
    };

    const onEditorStateChange = (newState) => {
        setIsSaved(false)
        if (typingTimeout) {
            clearTimeout(typingTimeout);
        }

        setEditorState(newState);

        const newTimeout = setTimeout(() => {
            const currentContent = newState.getCurrentContent();
            const rawContent = convertToRaw(currentContent);
            if (typeof rawContent !== "string") {
                const contentWithStyles = JSON.stringify(rawContent);
            }
            const htmlContent = draftToHtml(rawContent);

            if (htmlContent !== selectedNote.content) {
                handleUpdateNote(selectedNote.noteId, htmlContent);
                setIsSaved(true)
            }
        }, 1500);

        setTypingTimeout(newTimeout);
    };

    const handleAddNote = () => {

        if (selectedFolderId) {
            handleCreateNote(selectedFolderId, setSelectedSubmenuId)
        }
        else {
            handleCreateNote("", setSelectedSubmenuId)
        }
    }

    return (
        <div className="allnotes-container">
            <div className="allnotes-sidebar">
                <div className="allnotes-sidebar-header">
                    <NoteSearchInput onSearch={handleSearch} value={searchText} />
                    <AddNoteButton onClick={handleAddNote} />
                </div>

                <span className='notebook-search-title'>{searchText ? getTranslation("foundNotes") : getTranslation("recentNotes")}</span>
                <div style={{maxHeight:'100%',flexDirection:'column',display:'flex',overflowY:'auto',gap:'5px'}}>
                    {filteredNotes?.map((note) => {

                        const content = note.content || "";
                        const noteTitle = note.title || getTranslation("untitled");

                        const title =
                            noteTitle.length > 20 ? noteTitle.slice(0, 20) + "..." : noteTitle;

                        const stripHtmlTags = (html) => {
                            return html.replace(/<[^>]*>/g, '');
                        };

                        const text = content.length > 0 ?
                            (stripHtmlTags(content).length > 20 ? stripHtmlTags(content).slice(0, 20) + "..." : stripHtmlTags(content))
                            : '';

                        const dateObj = new Date(parseInt(note.createdDateTime) * 1000);
                        const day = String(dateObj.getDate()).padStart(2, '0');
                        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                        const year = dateObj.getFullYear();
                        const date = `${day}/${month}/${year}`;

                        let folderNote = note
                        if (note.folderId) {
                            folderNote = myNotes.folders?.flatMap(folder =>
                                folder.notes?.map(x => ({ ...x, folderTitle: folder.title })) || []
                            ).find(x => x.noteId === note.noteId);
                        }



                        return (
                            <NoteCard
                                key={note.noteId}
                                title={title}
                                text={text}
                                date={date}
                                isStarred={note.isStarred}
                                onHandleStar={() => { note.isStarred ? handleMenuUnstarNote(note.noteId) : handleMenuStarNote(note.noteId) }}
                                onDelete={() => { handleDeleteNoteTemporary(note.noteId); { selectedNote?.noteId === note.noteId && setSelectedNote(null) } }}
                                onClick={() => {
                                    setSelectedNote(folderNote);
                                    setSelectedSubmenuId(note.noteId);
                                    handleTouchNote(note.noteId);
                                    setSearchText("")
                                }}
                            />
                        );
                    })}
                </div>
            </div>

            <div className="allnotes-editor-area">
                <div className="notebook-header">
                    <div className="notebook-header-left">
                        {isEditingTitle ? (
                            <input
                                ref={titleInputRef}
                                autoFocus
                                value={tempTitle}
                                onChange={(e) => setTempTitle(e.target.value)}
                                onBlur={async () => {
                                    setIsEditingTitle(false);
                                    await handleSaveChanges();
                                    handleUpdateNoteTitle(selectedNote.noteId, tempTitle);
                                }}
                                onKeyDown={async (e) => {
                                    if (e.key === "Enter") {
                                        setIsEditingTitle(false);
                                        await handleSaveChanges();
                                        handleUpdateNoteTitle(selectedNote.noteId, tempTitle);
                                    }
                                }}
                                className="editable-title-input"
                            />
                        ) : (
                            <span onClick={() => {
                                setTempTitle(selectedNote?.title || getTranslation("untitled"));
                                setIsEditingTitle(true);
                            }}>
                                {breadcrumb()}
                            </span>
                        )}
                    </div>
                    {selectedNote &&
                        <div className="notebook-header-right">
                            {!isSaved && <div className="note-book-spinner"></div>}
                            <TfiSave className="notebook-header-right-button" size={16} onClick={handleSaveChanges} />
                            {selectedNote.isStarred ? <TbStarFilled className="notebook-header-right-button" size={16} onClick={() => handleUnstarNote(selectedNote.noteId)} /> : <TbStar className="notebook-header-right-button" size={16} onClick={() => handleStarNote(selectedNote.noteId)} />}
                            <TbTrash className="notebook-header-right-button" size={16} onClick={() => { handleDeleteNoteTemporary(selectedNote.noteId); setSelectedNote(null) }} />
                            {myNotes?.folders?.length > 0 && <TbFolderSymlink onClick={() => setIsModalOpen(true)} className="notebook-header-right-button" size={16} />}
                        </div>
                    }

                </div>
                {selectedNote ?
                    <NoteTextEditor
                        editorState={editorState}
                        setEditorState={onEditorStateChange} // OnChange handler'ı güncelledik
                    /> :
                    <span className='notebook-select-note'>{getTranslation('selectOrAddNote')}</span>
                }

                {isModalOpen &&
                    <NoteMoveFolderModal
                        onClose={() => setIsModalOpen(false)}
                    />
                }

            </div>
        </div>
    );
}
